import { ChangeDetectionStrategy, Component, output } from '@angular/core';

@Component({
  selector: 'rounded-button',
  standalone: false,
  templateUrl: './rounded-button.component.html',
  styleUrl: './rounded-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoundedButtonComponent {
  click = output();
}
